/**
 * @generated SignedSource<<bb7e823ed9941b2f03b05329404ae5d9>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type FraudAlertRouterQuery$variables = Record<PropertyKey, never>;
export type FraudAlertRouterQuery$data = {
  readonly authIdentity: {
    readonly creditApplications: ReadonlyArray<{
      readonly creditReport: {
        readonly entity: {
          readonly fraudAlertPhoneHint: string | null;
        } | null;
      } | null;
      readonly id: string;
    }>;
    readonly id: string;
  };
};
export type FraudAlertRouterQuery = {
  response: FraudAlertRouterQuery$data;
  variables: FraudAlertRouterQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v1 = [
      {
        alias: null,
        args: null,
        concreteType: 'Identity',
        kind: 'LinkedField',
        name: 'authIdentity',
        plural: false,
        selections: [
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'CreditApplication',
            kind: 'LinkedField',
            name: 'creditApplications',
            plural: true,
            selections: [
              v0 /*: any*/,
              {
                alias: null,
                args: null,
                concreteType: 'IdentityLinkCreditReport',
                kind: 'LinkedField',
                name: 'creditReport',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    concreteType: 'CreditReport',
                    kind: 'LinkedField',
                    name: 'entity',
                    plural: false,
                    selections: [
                      {
                        alias: null,
                        args: null,
                        kind: 'ScalarField',
                        name: 'fraudAlertPhoneHint',
                        storageKey: null,
                      },
                    ],
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'FraudAlertRouterQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'FraudAlertRouterQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '0ed6cda750baa993462fd0c352313869',
      id: null,
      metadata: {},
      name: 'FraudAlertRouterQuery',
      operationKind: 'query',
      text: 'query FraudAlertRouterQuery {\n  authIdentity {\n    id\n    creditApplications {\n      id\n      creditReport {\n        entity {\n          fraudAlertPhoneHint\n        }\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '79fe4454acb1017a0e84fed7aaba18c5';

export default node;
